import TargetDefinition from './components/TargetDefinition.vue'

export { default as createModule } from './store'
export default TargetDefinition



// WEBPACK FOOTER //
// ./src/app/appComponents/workbench/targetDefinition/index.js